<template>
    <v-container>
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
<!--                <span class="header bold text-tcdc-green text-uppercase">{{ $t('service.membership') }}</span>-->
                <span class="header bold text-tcdc-green text-uppercase">{{membership && membership[`name_${lang}`]}}</span>
                <Membership />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExpandable from "../../components/expandables/ServiceExpandable";
    import { mapState } from 'vuex';
    import Membership from "../../components/member_layouts/Membership";
    import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

    export default {
        async created() {
          this.items = BreadcrumbUtil.setServiceItem(
              this.items,
              this.branchId,
              this.branchName,
              this.allBranches,
              this.lang
          )
            if (this.$route.params.branch) {
                let params = { branch_id: 0, lang: this.lang };
                for (const b of this.allBranches) {
                    if (this.$route.params.branch === b.tag_name) {
                        if (!this.$route.params.branch) {
                            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                            break;
                        }
                        params.branch_id = b.branch_id;
                        if (this.$route.params.branch === 'mini-tcdc') {
                            await this.$store.dispatch('Branch/getMiniByBranch', params);
                            break;
                        }
                        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                        await this.$store.dispatch("Branch/getBranchById", params.branch_id);
                        break;
                    }
                }
            } else {
                if (this.branchId !== 0) {
                    let params = { branch_id: 0, lang: this.lang };
                    await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                    await this.$store.dispatch("Branch/getBranchById", params.branch_id);
                }
            }
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                allBranches: state => state.Branch.branches,
                branchId: state => state.Branch.branch_id,
                lang: state => state.Branch.lang,
                membership : state=>{
                    return state.ServiceMenu.membership_main;
                },
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
              this.items = BreadcrumbUtil.setServiceItem(
                  this.items,
                  this.branchId,
                  this.branchName,
                  this.allBranches,
                  this.lang
              )
            }
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    disabled: false,
                    // href: "breadcrumbs_dashboard",
                    to: "/home/:branch"
                },
                {
                    text: "SERVICE",
                    disabled: false,
                    to: "/:branch/service",
                    href: "/:branch/service",
                    // to: "/service"
                },
                {
                    text: "MEMBERSHIP",
                    disabled: true,
                    // href: "breadcrumbs_link_1",
                }
            ]
        }),
        components: {
            Membership,
        }
    };
</script>

<style></style>
